import { ErrorListener } from "antlr4";
//const path = require('path');

// const {SyntaxGenericError} = require(path.resolve('error', 'helper'));

/**
 * Custom Error Listener
 *
 * @returns {object}
 */
class MyErrorListener extends ErrorListener {
  constructor(errorsList) {
    super();
    this.errorsList = errorsList;
  }

  /**
   * Checks syntax error
   *
   * @param {object} recognizer The parsing support code essentially. Most of it is error recovery stuff
   * @param {object} symbol Offending symbol
   * @param {int} line Line of offending symbol
   * @param {int} column Position in line of offending symbol
   * @param {string} message Error message
   * @param {string} payload Stack trace
   */
  syntaxError(recognizer, symbol, line, column, message) {
    let lang = navigator.languages;
    const arrowMissing = ["Faltando →", "Without →"];
    const valueMissing = [
      "Regra faltando definição",
      "Rule definition missing",
    ];
    // const valeEmpty = ["Empty field", "Campo vazio"];
    const lineMissing = ["Linha", "Line"];
    const columnMissing = ["Coluna", "Column"];
    let index = 1;
    let containsPT = false;
    lang.every((ele) => {
      if (ele.includes("pt")) {
        containsPT = true;
      }
    });
    if (containsPT) {
      index = 0;
    }

    let messageError =
      lineMissing[index] +
      ": " +
      line +
      " " +
      columnMissing[index] +
      ": " +
      column +
      " ";

    if (
      message.includes("expecting '→'") ||
      message.includes("expecting '\\u2192'")
    ) {
      messageError += arrowMissing[index];
    } else if (
      message.includes(
        "expecting {WDCOMPLEX, WDSYMDIG, APOSUPPW, UNIUPPW, UPPW, 'λ'}"
      )
    ) {
      messageError += valueMissing[index];
    } else {
      messageError += message;
    }

    this.errorsList.push(messageError);
  }
}

export default MyErrorListener;
